import LazyLoad from 'react-lazyload';
import Button from '@alltrails/shared/denali/components/Button';
import * as styles from './styles/styles.module.scss';

// We're going to have a lot of seasonal variants of this gifting banner
// so we can just compose the variants using this one as a base

export type Props = {
  title: string;
  subtext: string;
  imgSrc: string;
  ctaText: string;
  ctaLink: string;
};

const GiftingBlockBase = ({ title, subtext, imgSrc, ctaText, ctaLink }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img src={imgSrc} alt="giftcard" className={styles.image} loading="lazy" />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subText}>{subtext}</div>
        <Button
          text={ctaText}
          onClick={
            // no need for onClick with href
            () => {}
          }
          linkInfo={{ href: ctaLink }}
          testId="gift-pro"
          variant="primary"
        />
      </div>
    </div>
  );
};

export default GiftingBlockBase;
